import packageApi from '../../api/package.api.js'

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
	// 获取所有套餐列表
	getPackageList(context) {
		return packageApi.packageList()
	},

	// 创建订单
	postCreateOrder(context, data) {
		return packageApi.createOrder(data)
	},
	// 查询订单状态：
	getUpdateOrderStatus(context, data) {
		return packageApi.updateOrderStatus(data)
	},
	// 查询订单列表：
	getOrderList(context, data) {
		return packageApi.orderList(data)
	},
	/**
	 * 购物车-根据suitId获取对应套餐信息
	 * @param {String} params.suitId
	 */
	getShopingCartBySuitId(context, params) {
		return packageApi.getShopingCartBySuitId(params)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
